(() => {
  if (window.__robotimeComingSoonLaunchFilter) return;
  window.__robotimeComingSoonLaunchFilter = true;

  let selectedMonth = '';
  let scheduled = false;

  const readMap = (section) => {
    const source = section.querySelector('script[data-coming-soon-release-map]');
    if (!source) return new Map();

    try {
      return new Map(JSON.parse(source.textContent).map((item) => [item.handle, item.month]));
    } catch (error) {
      console.warn('Coming Soon launch-date filter could not read its product dates.', error);
      return new Map();
    }
  };

  const getSelectedLabel = (section) => {
    const input = [...section.querySelectorAll('input[name="coming-soon-launch-month"]')]
      .find((option) => option.value === selectedMonth);

    return input?.labels?.[0]?.textContent?.trim() || selectedMonth;
  };

  const removeLaunchChip = (section) => {
    section.querySelectorAll('[data-coming-soon-launch-chip]').forEach((chip) => chip.remove());
    section.querySelectorAll('[data-coming-soon-launch-active-facets]').forEach((host) => {
      if (!host.children.length) host.remove();
    });
  };

  const renderLaunchChip = (section) => {
    if (!selectedMonth) {
      removeLaunchChip(section);
      return;
    }

    const label = `Launch Date: ${getSelectedLabel(section)}`;
    const existingChip = section.querySelector('[data-coming-soon-launch-chip]');

    if (existingChip) {
      const text = existingChip.querySelector('.text-subdued');
      if (text && text.textContent !== label) text.textContent = label;
      return;
    }

    let host = section.querySelector('.collection__main > .active-facets');

    if (!host) {
      host = document.createElement('div');
      host.className = 'active-facets';
      host.setAttribute('data-coming-soon-launch-active-facets', '');
      const productList = section.querySelector('.collection__main > product-list');
      if (productList) productList.before(host);
    }

    const chip = document.createElement('div');
    chip.className = 'removable-facet';
    chip.setAttribute('data-coming-soon-launch-chip', '');
    chip.innerHTML = `
      <button type="button" class="tap-area link-faded" aria-label="Remove Launch Date filter" data-coming-soon-launch-clear>
        <svg aria-hidden="true" focusable="false" fill="none" width="10" viewBox="0 0 10 10">
          <path d="m1 1 8 8M9 1 1 9" stroke="currentColor" stroke-linecap="square"></path>
        </svg>
      </button>
      <span class="text-subdued">${label}</span>
    `;
    host.append(chip);
  };

  const applyToSection = (section) => {
    const monthMap = readMap(section);
    if (!monthMap.size) return;

    const cards = [...section.querySelectorAll('product-card[handle]')];
    let visibleCount = 0;

    cards.forEach((card) => {
      const hidden = Boolean(selectedMonth && monthMap.get(card.getAttribute('handle')) !== selectedMonth);
      card.classList.toggle('coming-soon-launch-hidden', hidden);
      card.toggleAttribute('aria-hidden', hidden);
      if (!hidden) visibleCount += 1;
    });

    section.querySelectorAll('input[name="coming-soon-launch-month"]').forEach((input) => {
      input.checked = Boolean(selectedMonth && input.value === selectedMonth);

      if (selectedMonth) {
        const details = input.closest('details');
        if (details && !details.open) details.open = true;
      }
    });

    renderLaunchChip(section);

    section.querySelectorAll('.collection-toolbar__products-count').forEach((counter) => {
      const currentText = counter.textContent;
      const nextText = /\d+/.test(currentText)
        ? currentText.replace(/\d+/, String(visibleCount))
        : currentText;

      if (nextText !== currentText) counter.textContent = nextText;
    });
  };

  const applyAll = () => {
    document.querySelectorAll('script[data-coming-soon-release-map]').forEach((source) => {
      const section = source.closest('.shopify-section');
      if (section) applyToSection(section);
    });
  };

  const scheduleApply = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyAll();
    });
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('input[name="coming-soon-launch-month"]');
    if (!input) return;

    selectedMonth = input.checked ? input.value : '';
    applyAll();
  });

  document.addEventListener('click', (event) => {
    const clearButton = event.target.closest('[data-coming-soon-launch-clear]');
    if (!clearButton) return;

    event.preventDefault();
    selectedMonth = '';
    applyAll();
  }, true);

  document.addEventListener('shopify:section:load', scheduleApply);

  new MutationObserver(scheduleApply).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll, { once: true });
  } else {
    applyAll();
  }
})();